export default __webpack_public_path__ + "static/media/7.dcd87132.jpg";